module.exports = __webpack_public_path__ + "static/media/2025_1_MOBILE.427ab746.png";